import React from 'react';
import { styled } from 'styled-components';
const TagWrapper = styled.span `
  font-size: 0.8em;
  padding: 0.4em 0.8em;
  border-radius: 100em;
  background: #ccc;
  color: #000;
  display: block;
  margin-right: 0.4em;
  margin-bottom: 6px;
`;
const Tag = (props) => (React.createElement(TagWrapper, null, props.children));
export default Tag;
//# sourceMappingURL=Tag.js.map